import React from "react";
import styles from "./PrivacyPolicyPage.module.scss";

import Footer from '../../components/Footer/Footer';

const PrivacyPolicy = () => {
  return (
    <>
        <div className={styles.container}>
            <div className={styles.content}>
                <h1>Politique de confidentialité</h1>
                <hr />
                <p>
                    Nous attachons une grande importance à la protection de vos données personnelles. 
                    Cette politique de confidentialité vous explique comment nous collectons, utilisons 
                    et protégeons vos informations.
                </p>

                <h2>1. Données collectées</h2>
                <p>Nous collectons les données suivantes :</p>
                <ul>
                    <li>Pseudo (qui peut être affiché aux autres utilisateurs lors du classement général du jeu)</li>
                    <li>Adresse email</li>
                    <li>Code postal (utilisé uniquement à des fins statistiques)</li>
                </ul>

                <h2>2. Base légale du traitement</h2>
                <p>
                    Le traitement de vos données personnelles repose sur les bases légales suivantes&nbsp;:
                </p>
                <ul>
                    <li>Exécution du contrat lorsque vous utilisez notre service.</li>
                    <li>Intérêt légitime pour l'affichage du classement général des joueurs.</li>
                </ul>

                <h2>3. Durée de conservation</h2>
                <p>
                    Vos données personnelles sont conservées pendant une durée de <strong>3 ans</strong>&nbsp; 
                    après votre dernière activité sur notre service. <br/>Passé ce délai, elles seront supprimées.
                </p>

                <h2>4. Utilisation des données</h2>
                <p>Nous utilisons vos données uniquement pour&nbsp;:</p>
                <ul>
                    <li>Assurer le bon fonctionnement du service</li>
                    <li>Vous permettre de vous connecter</li>
                    <li>Établir des statistiques de jeu et un classement général entre joueurs (affichage du pseudo uniquement)</li>
                    <li>Analyser la répartition géographique des joueurs (via le code postal, de manière anonyme)</li>
                </ul>

                <h2>5. Protection de vos données</h2>
                <p>
                    Nous mettons en place des mesures techniques et organisationnelles adéquates pour 
                    protéger vos informations contre tout accès non autorisé, altération, divulgation ou destruction.
                    Ces mesures incluent le chiffrement des données et des contrôles d'accès stricts.
                </p>

                <h2>6. Vos droits</h2>
                <p>
                    Conformément au RGPD, vous avez les droits suivants&nbsp;:
                </p>
                <ul>
                    <li>Droit d'accès : vous pouvez obtenir une copie de vos données.</li>
                    <li>Droit de rectification : vous pouvez corriger vos informations.</li>
                    <li>Droit de suppression : vous pouvez demander la suppression de vos données.</li>
                    <li>Droit à la portabilité : vous pouvez recevoir vos données dans un format structuré.</li>
                    <li>Droit à la limitation du traitement : sous certaines conditions, vous pouvez demander à restreindre l'utilisation de vos données.</li>
                </ul>
                <p>
                    Pour exercer ces droits, contactez-nous à l'adresse suivante&nbsp;:&nbsp;
                    <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a>.
                </p>

                <h2>7. Recours auprès de la CNIL</h2>
                <p>
                    Si vous estimez que vos droits ne sont pas respectés, vous pouvez déposer une réclamation 
                    auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) sur leur site officiel&nbsp;:
                    <a className={styles.link} href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer"> www.cnil.fr</a>.
                </p>

                <h2>8. Transfert des données hors UE</h2>
                <p>
                    Vos données sont stockées au sein de l'Union européenne. Aucun transfert en dehors de l’UE n’est réalisé. Vos données ne sont pas transmises à des tiers.
                </p>
            </div>
        </div>

        <Footer/>
    </>
  );
};

export default PrivacyPolicy;
